import { createContext } from 'react';
import { MarketsContextValue } from './types';

export const MarketsContext = createContext<MarketsContextValue>(
  {} as MarketsContextValue,
);
MarketsContext.displayName = 'MarketsContext';
